export default {"src":"/_next/static/media/NZD.f1f77c24.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};